import * as React from 'react';
const Pencil = ({
	fill = '#03488E',
	...props
}: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 18 18"
		fill="none"
		{...props}
	>
		<path
			fill={fill}
			d="M17.71 4.04c.39-.39.39-1.04 0-1.41L15.37.29C15-.1 14.35-.1 13.96.29l-1.84 1.83 3.75 3.75M0 14.25V18h3.75L14.81 6.93l-3.75-3.75L0 14.25Z"
		/>
	</svg>
);
export default Pencil;
